// extracted by mini-css-extract-plugin
export var banner = "_2f-0";
export var icon = "_2f-1";
export var message = "_2f-2";